const RULE_QUESTION_TYPES = [
  'multiple_choice'
];

export default RULE_QUESTION_TYPES;
